import React from 'react';

export default function RemoveDiacritic(stringValue) {

  return stringValue
    .toLowerCase()
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '');
}
